import emptySplitApi from "../utils/rtk";

import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
    statusCode: number;
    message: string;
    s3Location?: string
};




interface QueryParams {
    userId?: any;
    page?: number;
    limit?: number;
}

export const actionTrackerApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({

        getAllActionTracker: builder.query<CommonResponseType & { data: any }, {
            page?: number; search?: string, limit?: number, startDate?: string, endDate?: string, propertyTypeId?: string, categoryId?: string,
            categoryParentId?: string, listingType?: number | string, agencyType?: number, isRent?: boolean, isBuy?: boolean, agentId?: string
        }>({
            query: ({ page, search, limit, startDate, endDate, propertyTypeId, categoryId, categoryParentId, listingType, agencyType, isRent, isBuy ,agentId}) => {
                let url = `${END_POINTS.listingActionTracker}?page=${page}&search=${search}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&propertyTypeId=${propertyTypeId}&categoryId=${categoryId}&categoryParentId=${categoryParentId}&listingType=${listingType}&agencyType=${agencyType}&agentId=${agentId}${isBuy ? `&isBuy=true` : ""}${isRent ? `&isRent=true` : ""}`;
                return {
                    url: url,
                    method: "GET",
                };
            },
            keepUnusedDataFor: 1,
            providesTags: ["GETACTIONTRACKER"]
        }),

        deleteActionTracker: builder.mutation<CommonResponseType & { data: any }, { id: string }>({
            query: ({ id }) => {
                let url = `${END_POINTS.listingActionTracker}/delete/${id}`;
                return {
                    url: url,
                    method: "DELETE",
                };
            },
            invalidatesTags: ["GETACTIONTRACKER"]
        }),

        getAllActionTrackerByCompany: builder.query<CommonResponseType & { data: any }, {
            page?: number; search?: string, limit?: number, agentId: any, propertyTypeId?: string, categoryId?: string,
            categoryParentId?: string, listingType?: number | string, agencyType?: number, isRent?: boolean, isBuy?: boolean
        }>({
            query: ({ page, search, limit, agentId, propertyTypeId, categoryId, categoryParentId, listingType, agencyType, isRent, isBuy }) => {
                let url = `${END_POINTS.listingActionTracker}?page=${page}&search=${search}&limit=${limit}&agentId=${agentId}&propertyTypeId=${propertyTypeId}&categoryId=${categoryId}&categoryParentId=${categoryParentId}&listingType=${listingType}&agencyType=${agencyType}${isBuy ? `&isBuy=true` : ""}${isRent ? `&isRent=true` : ""}`;
                return {
                    url: url,
                    method: "GET",
                };
            },

        }),

        getAllActionTrackerForXml: builder.query<CommonResponseType & { data: any }, {
            page?: number; search?: string, limit?: number, companyId: any, isXmlUpdate?: boolean, startDate?: string, endDate?: string,

        }>({
            query: ({ page, search, limit, companyId, isXmlUpdate, startDate, endDate, }) => {
                let url = `${END_POINTS.listingActionTracker}?page=${page}&search=${search}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&companyId=${companyId}${isXmlUpdate ? `&isXmlUpdate=true` : ""}`;
                return {
                    url: url,
                    method: "GET",
                };
            },

        }),



    }),
});

export const {
    useGetAllActionTrackerQuery,
    useDeleteActionTrackerMutation,
    useLazyGetAllActionTrackerByCompanyQuery,
    useLazyGetAllActionTrackerForXmlQuery
} = actionTrackerApi;
